var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7633 21.7487L18.3086 15.9054C19.9989 14.2159 21.0374 11.9815 21.0374 9.52279C21.0366 4.26316 16.3276 0 10.5183 0C4.70901 0 0 4.26316 0 9.52279C0 14.7824 4.70901 19.0456 10.5183 19.0456C13.0283 19.0456 15.3305 18.2469 17.1388 16.919L23.6185 22.7854C23.9342 23.0715 24.4468 23.0715 24.7626 22.7854C25.079 22.4993 25.079 22.0349 24.7633 21.7487ZM10.5183 17.5804C5.603 17.5804 1.61839 13.9729 1.61839 9.52279C1.61839 5.07266 5.603 1.46514 10.5183 1.46514C15.4336 1.46514 19.4182 5.07266 19.4182 9.52279C19.4182 13.9729 15.4336 17.5804 10.5183 17.5804Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.649341ea9b1401fae17ae3ce0f72f02a.svg";
export { ForwardRef as ReactComponent };